import { render } from "./PMAnalyticsChart.vue?vue&type=template&id=20af8d16&scoped=true"
import script from "./PMAnalyticsChart.vue?vue&type=script&lang=ts"
export * from "./PMAnalyticsChart.vue?vue&type=script&lang=ts"

import "./PMAnalyticsChart.vue?vue&type=style&index=0&id=20af8d16&lang=scss&scoped=true"
import "./PMAnalyticsChart.vue?vue&type=style&index=1&id=20af8d16&lang=css"
script.render = render
script.__scopeId = "data-v-20af8d16"

export default script